import styles from './BackgroundGrid.module.css';

const BackgroundGrid = (): React.ReactElement => (
  <div className={styles.bgGrid} aria-hidden="true" />
);

export { BackgroundGrid };
